import React from 'react'
import PriceFormatter from '../../../utils/price-formatter'
import createReactClass from 'create-react-class'


var ProductListTotal = createReactClass({

	getPriceTotal: function () {
		var price = 0.0;
		for (var i = 0; i < this.props.items.length; i++) {
			price += this.props.items[i].getPrice(10);
		}
		return Math.round(price*100)/100;
	},
	getTotalNumberOfItems: function () {
		var quantity = 0;
		for (var i = 0; i < this.props.items.length; i++) {
			quantity += this.props.items[i].getQuantity();
		}
		return quantity;
	},
	render: function() {
		return (
			<div className="ope-section__footer__summary row">
				<span className="ope-section__footer__quantity small-9 medium-9 columns">{_("You’re ordering %s photos", this.getTotalNumberOfItems())} </span>
				<span className="small-3 medium-3 columns ope-section__footer__price ope-grid-column-nopadding"> { PriceFormatter(this.getPriceTotal()) } </span>
			</div>
		);

	}
});

export default ProductListTotal;
